import { TrainStrikeHAWGame } from './TrainStrikeHAWGame'
import { GAME_LOCALISATION } from './locale/Localisation'
import { bootstrapInterface } from '@1x2network/duck_slot_game'
import { SLOT_LOCALISATION } from '@1x2network/legacy_localisation'

const game = new TrainStrikeHAWGame()

await game.initialise({ locale: { game: GAME_LOCALISATION } })
await game.preload()

bootstrapInterface(game, {
    enableQuickSpin: true,
    paytable: {
        '8': [SLOT_LOCALISATION.get('paytable_symbol-wild')],
        '9': [GAME_LOCALISATION.get('paytable_symbol-09-collector')],
        '10': [GAME_LOCALISATION.get('paytable_symbol-10-cash')],
        '11': [GAME_LOCALISATION.get('paytable_symbol-11-mini')],
        '12': [GAME_LOCALISATION.get('paytable_symbol-12-minor')],
        '13': [GAME_LOCALISATION.get('paytable_symbol-13-major')],
        '14': [GAME_LOCALISATION.get('paytable_symbol-14-mega')],
        '15': [SLOT_LOCALISATION.get('paytable_symbol-blank')],
    },
    antebet: {
        100: {
            title: GAME_LOCALISATION.get('antebet_title-100'),
            description: GAME_LOCALISATION.get('antebet_description-100'),
        },
    },
})

// load the game and run it
await game.load()
game.run()
